/** Figma 6161:2383 / 6161:3182 — Instrument Dashboard spacing (intent-based). */
export const INSTRUMENT_DASHBOARD_LAYOUT = {
  /** Desktop-only target per BFP-654 (≥1024px). */
  desktopMinWidth: 1024,
  /** AppShell main already applies 24px; add 8px → 32px horizontal per Figma. */
  pagePx: '8px',
  titleToBreadcrumb: '14px',
  /** Question Drill-Down — page title to subtitle (px). */
  titleToSubtitle: '8px',
  titleBlockToBreadcrumb: '18px',
  breadcrumbToMetrics: '32px',
  metricsToTimeline: '20px',
  /** Figma 6161:2502 → 6161:2501 — collection timeline to All Questions row (32px). */
  timelineToQuestionsHeader: '32px',
  filterChipsToQuestions: '12px',
  timelineToMainGrid: '24px',
  mainToRailGap: 2.5,
  sectionGap: '25px',
  sectionHeadingToContent: '20px',
  railSectionGap: '32px',
  /** Figma 6161:1932 → 6161:1933 — recommendations heading to cards (52 − 32). */
  railHeadingToContent: '20px',
  metricsToQuestions: '25px',
  questionsHeaderPt: '0px',
  questionsHeaderToList: '20px',
  questionCardGap: '16px',
  /** Figma 6161:2501 → 6161:3013 — All Questions block to Top Answers table. */
  questionsToTopAnswers: '25px',
  metricCardGap: '20px',
  breadcrumbGap: '4px',
  /** Figma 6161:2390 — instrument metric tile; height trimmed slightly from 189px design. */
  metricTileAspectRatio: '222 / 160',
  metricTileMinHeightPx: 160,
  collectionTimelinePadding: '20px',
  genderSplitCardPadding: '20px',
  /** Figma 6161:2429 — doughnut plot area. */
  genderSplitChartWidthPx: 197,
  genderSplitChartHeightPx: 186,
  /** Figma 6161:2436–6161:2448 — legend row gap (24px). */
  genderSplitLegendRowGap: '24px',
  insightCardGap: '16px',
  recommendationListGap: '8px',
} as const

export const INSTRUMENT_DASHBOARD_PAGE_SX = {
  bgcolor: '#F9FAFB',
  minHeight: '100%',
  px: INSTRUMENT_DASHBOARD_LAYOUT.pagePx,
  pb: '24px',
} as const

/** Figma 6161:2456 / 6161:2501 — section titles (AI Insights, All Questions). */
export const INSTRUMENT_DASHBOARD_SECTION_HEADING_SX = {
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: '28px',
  color: '#0B1C30',
  m: 0,
} as const

/** Figma 6161:2490 — Instrument Recommendations title. */
export const INSTRUMENT_DASHBOARD_RECOMMENDATIONS_HEADING_SX = {
  fontWeight: 600,
  fontSize: '20px',
  lineHeight: '28px',
  color: '#7E22CE',
  m: 0,
} as const

/** Question Drill Down — vertical spacing between summary, filters, and chart (px). */
export const QUESTION_DRILLDOWN_LAYOUT = {
  summaryToFilterTabs: '32px',
  filterTabsToChart: '32px',
  chartToFindings: '40px',
  sectionGap: '20px',
  interpretationToNotes: '48px',
} as const
